module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Light.ttf
// module id = ../../../../../src/assets/font/roboto/Roboto-Light.ttf
// module chunks = 29